import ScopeFilter from './ScopeFilter';

export default {
  scopeFilter: [ 'type', ScopeFilter ]
};